import { useSelector } from 'react-redux'

const useBranding = () => {
	return useSelector(
		state => Boolean(state.branding?.backgroundColor) && state.branding
	)
}


export default useBranding